import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Integration  extends Component {
    

    render() {

        var example = JSON.stringify({
            "sender_amount": "2",
            "receiver_amount": "121.75",
            "fees": "0.000",
            "currrates": "60.8753"
            }, null, 2)

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        
      
        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                    <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">
                            Integration Notes &amp; Data Type Standards
                        </h1>

                        <section class="docs-intro">
                            <p>
                                The following standards define the expected data types for all
                                remittance API requests. To ensure successful validation and
                                transaction processing, all monetary values must be submitted as
                                <span class="highlight"> String </span> values.
                            </p>
                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Field Data Types
                            </h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>Field Category</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Amount Fields</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Exchange Rate</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Fees</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Session ID</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Country Code</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Corridor</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Location ID</td>
                                        <td>String</td>
                                    </tr>

                                    <tr>
                                        <td>Branch Code</td>
                                        <td>String</td>
                                    </tr>
                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Example
                            </h2>

                            <pre>
                                <code class="copybox-code">
                                    {example}
                                </code>
                            </pre>

                        </section>
                    </article> 

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-authentication"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Authentication
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-integration-workflow"
                                            >
                                                Integration Workflow&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}